import styled from 'styled-components';
export const Wrapper = styled.div<{ sort?: string }>`
  ${({ sort }) => `
    ${sort !== 'newest' && `transform: scaleY(-1)`}
  `}
`;
